import AppData from '../../api/AppData'
import AppVideo from '../../components/AppVideo/AppVideo.vue'

export default {
    components: {
        AppVideo,
    },
    data() {
        return {
            data: AppData,
            videoId: ''
        }
    },
    mounted() {
        const type = (this.$route.params.type === 'interview') ? 'video_interview' : 'video_documentary'
        this.videoId = this.data.markers.find((marker) => marker.slug === this.$route.params.slug)[type]
    }
}
